// extracted by mini-css-extract-plugin
module.exports = {"header":"Camera_header__2wjIn","video":"Camera_video__1u_FE"};